export const defaultLanguage = 'en' as const;
export type DefaultLanguage = typeof defaultLanguage;
export const defaultTimeZone = 'America/Puerto_Rico';
